// ============================================================
// RETFLOW BRAND CONFIG
// Change your brand name, email, domain, and colors here.
// These values are used across every page automatically.
// ============================================================

const BRAND = {
  // --- YOUR COMPANY NAME ---
  name: 'RetFlow',           // Short name shown in the logo
  fullName: 'RetFlow AI',    // Full name used in headings and emails
  tagline: 'Customer support that thinks, acts, and learns',

  // --- YOUR CONTACT INFO ---
  email: 'hello@retflow.ai',         // Contact/support email
  supportEmail: 'support@retflow.ai', // Where support tickets go

  // --- YOUR DOMAIN ---
  domain: 'retflow.ai',
  appUrl: 'https://retflow.ai',
  apiUrl: 'https://api.retflow.ai',

  // --- COLORS ---
  // Change these to match your brand
  accent: '#f59e0b',          // Main accent color (gold by default)
  accentHover: '#fbbf24',     // Slightly lighter for hover states
  accentText: '#09090b',      // Text color on accent backgrounds (dark)

  // --- SOCIAL ---
  twitter: 'https://twitter.com/retflow',
  linkedin: 'https://linkedin.com/company/retflow',

  // --- PRICING ---
  plans: {
    starter: { name: 'Starter', price: 97, bots: 1, convos: 500 },
    growth:  { name: 'Growth',  price: 297, bots: 3, convos: 2000 },
    agency:  { name: 'Agency',  price: 597, bots: -1, convos: -1 }, // -1 = unlimited
  },
};

export default BRAND;